// extracted by mini-css-extract-plugin
export default {"heading":"Products_heading__7Blpy","name":"Products_name__Vsgq4","subcontent":"Products_subcontent__hF3Qq"};